import React from "react";
import { useIntl, defineMessages } from "react-intl";
import { FOLLOW_UP, STATUSES } from "../../../globals/workOrderStatus";

import TaskOnSiteStatusIcon from "./taskOnSiteStatusIcon";
import TaskAssignStatusIcon from "./taskAssignStatusIcon";
import TaskEnrouteStatusIcon from "./taskEnrouteStatusIcon ";
import TaskCompleteStatusIcon from "./taskCompleteStatusIcon";
import TaskIncompleteStatusIcon from "./taskInCompleteStatusIcon";
import TaskCancelledStatusIcon from "./taskCancelledStatusIcon";

import TaskAssignActionIcon from "./taskAssignActionIcon";
import TaskUnassignActionIcon from "./taskUnassignActionIcon";
import TaskEnrouteActionIcon from "./taskEnrouteActionIcon";
import TaskOnsiteActionIcon from "./taskOnsiteActionIcon";
import TaskCompleteActionIcon from "./taskCompleteActionIcon";
import TaskIncompleteActionIcon from "./taskIncompleteActionIcon";
import TaskFollowupActionIcon from "./taskFollowupActionIcon";

const messages = defineMessages({
    assignedTooltip: {
        id: "status-icons.assigned-tooltip",
        defaultMessage: "Assigned",
        description: "Assigned action tooltip",
    },
    unassignedTooltip: {
        id: "status-icons.unassigned-tooltip",
        defaultMessage: "Unassigned",
        description: "Unassigned action tooltip",
    },
    enrouteTooltip: {
        id: "status-icons.enroute-tooltip",
        defaultMessage: "En route",
        description: "En Route action tooltip",
    },
    onsiteTooltip: {
        id: "status-icons.onsite-tooltip",
        defaultMessage: "On site",
        description: "On Site action tooltip",
    },
    completeTooltip: {
        id: "status-icons.complete-tooltip",
        defaultMessage: "Complete",
        description: "Complete action tooltip",
    },
    incompleteTooltip: {
        id: "status-icons.incomplete-tooltip",
        defaultMessage: "Incomplete job",
        description: "Incomplete action tooltip",
    },
    cancelledTooltip: {
        id: "status-icons.cancelled-tooltip",
        defaultMessage: "Cancelled",
        description: "Cancelled action tooltip",
    },
    followupTooltip: {
        id: "status-icons.followup-tooltip",
        defaultMessage: "Follow-up",
        description: "Follow-up action tooltip",
    },
});

export const WorkOrderStatusIcon = ({ id }) => {
    const intl = useIntl();

    switch (id) {
        case STATUSES.ASSIGNED:
            return <TaskAssignStatusIcon title={intl.formatMessage(messages.assignedTooltip)} />;

        case STATUSES.ENROUTE:
            return <TaskEnrouteStatusIcon title={intl.formatMessage(messages.enrouteTooltip)} />;

        case STATUSES.ONSITE:
            return <TaskOnSiteStatusIcon title={intl.formatMessage(messages.onsiteTooltip)} />;

        case STATUSES.COMPLETE:
            return <TaskCompleteStatusIcon title={intl.formatMessage(messages.completeTooltip)} />;

        case STATUSES.CLOSED_INCOMPLETE:
            return <TaskIncompleteStatusIcon title={intl.formatMessage(messages.incompleteTooltip)} />;

        case STATUSES.CANCELLED:
            return <TaskCancelledStatusIcon title={intl.formatMessage(messages.cancelledTooltip)} />;

        default:
            return <TaskAssignStatusIcon title={intl.formatMessage(messages.assignedTooltip)} />;
    }
};

export const WorkOrderActionIcon = (props) => {
    const intl = useIntl();

    switch (props.id) {
        case STATUSES.ASSIGNED:
            return <TaskAssignActionIcon {...props} title={intl.formatMessage(messages.assignedTooltip)} />;

        case STATUSES.UNASSIGNED:
            return <TaskUnassignActionIcon {...props} title={intl.formatMessage(messages.unassignedTooltip)} />;
        case STATUSES.ENROUTE:
            return <TaskEnrouteActionIcon {...props} title={intl.formatMessage(messages.enrouteTooltip)} />;

        case STATUSES.ONSITE:
            return <TaskOnsiteActionIcon {...props} title={intl.formatMessage(messages.onsiteTooltip)} />;

        case STATUSES.COMPLETE:
            return <TaskCompleteActionIcon {...props} title={intl.formatMessage(messages.completeTooltip)} />;

        case STATUSES.CLOSED_INCOMPLETE:
            return <TaskIncompleteActionIcon {...props} title={intl.formatMessage(messages.incompleteTooltip)} />;
        case STATUSES.CLOSED_INCOMPLETE:
            return <TaskIncompleteActionIcon {...props} title={intl.formatMessage(messages.incompleteTooltip)} />;

        case FOLLOW_UP.CREATE_FOLLOW_UP:
            return <TaskFollowupActionIcon {...props} title={intl.formatMessage(messages.followupTooltip)} />;

        default:
            return <TaskAssignActionIcon {...props} title={intl.formatMessage(messages.assignedTooltip)} />;
    }
};
